import { ToastContent } from '@/shared/components/Toast/Toast'
import { createSlice } from '@reduxjs/toolkit'

/**
 * Frontend-specific toast slice for global toast messages
 */
export const initialToastState: ToastContent = {
  open: false,
  severity: 'info',
  title: '',
  content: '',
}

export const toastSlice = createSlice({
  name: 'toast',
  initialState: initialToastState,
  reducers: {
    setToast: (_, action: { payload: ToastContent }) => {
      return action.payload
    },
    clearToast: (_) => {
      return initialToastState
    },
    closeToast: (state) => {
      state.open = false
    },
  },
})

export const { setToast, clearToast, closeToast } = toastSlice.actions
